<template>
  <div><NewParamaCourseComponent></NewParamaCourseComponent></div>
</template>

<script>
import NewParamaCourseComponent from "../../components/Courses/NewParamaCouse/NewParamaCourse.component.vue";
export default {
  components: {
    NewParamaCourseComponent,
  },
};
</script>

<style></style>
